import { format, isValid, parseISO } from 'date-fns';

export function convertAndFormatDate(shouldUseIsoDate: boolean, date = '') {
  const dateWithoutTimezone = shouldUseIsoDate
    ? parseISO(date)
    : new Date(date);

  const formattedDate = isValid(dateWithoutTimezone)
    ? format(dateWithoutTimezone, 'MM/dd/yyyy')
    : null;

  return { dateWithoutTimezone, formattedDate };
}
